import { StepperDesignTokens } from '@primeuix/themes/types/stepper';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tFlat, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/stepper/index.ts
const stp = componentCommon.stepper;

export const StepperAssessmentTelekomDT: StepperDesignTokens = {
  stepTitle: {
    ...tFlat(stp.step.title),
    fontWeight: tNum(stp.step.title.font.weight),
  },
  stepNumber: {
    ...tFlat(stp.step.number),
    fontWeight: tNum(stp.step.number.font.weight),
    shadow: 'none',
  },
  steppanel: tFlat(stp.steppanel),
  separator: tFlat(stp.separator),
  // checkmark when step complete
  css: `
    .p-step:has(~ .p-step-active) .p-step-number {
      background: var(--colours-functional-success-standard);
      border-color: var(--colours-functional-success-standard);
      font-size: 0;
    }
    .p-step:has(~ .p-step-active) .p-step-number::before {
      font-family: 'primeicons';
      content: '\\e909';
      font-size: var(--p-stepper-step-number-font-size);
      color: var(--colours-basic-text-on-accent);
    }
  `,
};
